import { call, put, takeLeading, delay } from 'redux-saga/effects';
import Actions from './actions';
import errorActions from '../error/actions';
import dxApi from 'services/dxApi';
const {
  Types: {
    LOAD_MVP_TRAINING_REQUEST,
    LOAD_SESSIONS_NEW_REQUEST,
    LOAD_USER_PACKAGES_REQUEST,
    LOAD_NOTIFICATION_REQUEST,
    UPDATE_NOTIFICATION_REQUEST,
    LOAD_QR_CODE_REQUEST,
  },
  Creators,
} = Actions;

const {
  Creators: { setError },
} = errorActions;

export function* getMvpTraningData() {
  try {
    const { data } = yield call(dxApi.get, `/api/training/fit-session/v2`);
    yield put(Creators.loadMvpTrainingSuccess(data.data));
  } catch (err) {
    yield put(Creators.loadMvpTrainingFailure(err));
    yield put(setError('Something went wrong'));
  }
}

export function* loadSessionNew({ data }) {
  let caId = data.caId;
  let body = {
    pageIndex: data.pageIndex,
    pageSize: data.pageSize,
  };
  try {
    const response = yield call(
      dxApi.post,
      `/api/training/all-upcoming-sessions-web-v2/${caId}`,
      body
    );
    // const response = yield call(dxApi.get, `/api/training/all-upcoming-sessions-dummy`);
    yield put(Creators.loadSessionsNewSuccess(response?.data));
  } catch (err) {
    yield put(Creators.loadSessionsNewFailure(err));
    yield put(setError('Something went wrong'));
  }
}

export function* loadUserPackages({ caId }) {
  try {
    const { data } = yield call(dxApi.get, `/api/training/my-user-packages/${caId}`);
    yield put(Creators.loadUserPackagesSuccess(data));
  } catch (err) {
    yield put(Creators.loadUserPackagesFailure(err));
    yield put(setError('Something went wrong'));
  }
}

export function* loadNotification({ userId }) {
  try {
    const { data } = yield call(
      dxApi.get,
      `notification/notification-web-setting-by-id-v2?userId=${userId}`
    );
    yield put(Creators.loadNotificationSuccess(data.data));
  } catch (err) {
    yield put(Creators.loadNotificationFailure(err));
    yield put(setError('Something went wrong'));
  }
}

export function* updateNotification({ data }) {
  try {
    const response = yield call(
      dxApi.post,
      `notification/update-notification-settings-v2`,
      data
    );
    yield put(Creators.updateNotificationSuccess(response?.data?.data));
    if (response) {
      yield delay(2000);
      window.location.reload();
    }
  } catch (err) {
    yield put(Creators.updateNotificationFailure(err));
    yield put(setError('Something went wrong'));
  }
}

// old qrcode api endpoint function
// export function* getQRCode({ caId }) {
//   try {
//     const { data } = yield call(dxApi.get, `/api/profile/scan-code/v3/${caId}`);
//     yield put(Creators.loadQRCodeSuccess(data));
//   } catch (err) {
//     yield put(Creators.loadQRCodeFailure(err));
//     yield put(setError('Something went wrong'));
//   }
// }

export function* getQRCode({ caId }) {
  try {
    const { data } = yield call(dxApi.get, `/api/profile/qr-code`, {
      params: {
        caid: caId,
      },
    });
    yield put(Creators.loadQRCodeSuccess(data));
  } catch (err) {
    yield put(Creators.loadQRCodeFailure(err));
    yield put(setError('Something went wrong'));
  }
}

export function* homePageNewSaga() {
  yield takeLeading(LOAD_MVP_TRAINING_REQUEST, getMvpTraningData);
  yield takeLeading(LOAD_SESSIONS_NEW_REQUEST, loadSessionNew);
  yield takeLeading(LOAD_USER_PACKAGES_REQUEST, loadUserPackages);
  yield takeLeading(LOAD_NOTIFICATION_REQUEST, loadNotification);
  yield takeLeading(UPDATE_NOTIFICATION_REQUEST, updateNotification);
  yield takeLeading(LOAD_QR_CODE_REQUEST, getQRCode);
}
